import { FormEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../components/Button';
import { subscribe } from '../lib/mailchimp';
import './Waitlist.css';

type Status = 'idle' | 'loading' | 'success' | 'error';

export function Waitlist() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<Status>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (status === 'loading') return;
    setStatus('loading');
    setErrorMsg('');
    const result = await subscribe(email.trim());
    if (result.ok) {
      setStatus('success');
      setEmail('');
      return;
    }
    setStatus('error');
    setErrorMsg(
      result.error === 'invalid_email'
        ? t('waitlist.errorInvalidEmail')
        : t('waitlist.errorGeneric'),
    );
  }

  return (
    <section id="waitlist" className="section section--dark">
      <div className="container container-narrow">
        <div className="section-header">
          <span className="eyebrow">{t('waitlist.eyebrow')}</span>
          <h2>{t('waitlist.title')}</h2>
          <p>{t('waitlist.subtitle')}</p>
        </div>

        {status === 'success' ? (
          <div className="waitlist-success">
            <span className="waitlist-success__check" aria-hidden="true">✓</span>
            <h3>{t('waitlist.successTitle')}</h3>
            <p>{t('waitlist.successBody')}</p>
          </div>
        ) : (
          <form className="waitlist-form" onSubmit={onSubmit} noValidate>
            <label className="waitlist-form__field">
              <span className="visually-hidden">{t('waitlist.emailLabel')}</span>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t('waitlist.emailPlaceholder')}
                aria-label={t('waitlist.emailLabel')}
                aria-invalid={status === 'error'}
                disabled={status === 'loading'}
              />
            </label>
            <Button type="submit" size="lg" disabled={status === 'loading'}>
              {status === 'loading' ? t('waitlist.submitting') : t('waitlist.submit')}
            </Button>
          </form>
        )}

        {status === 'error' && <p className="waitlist-error" role="alert">{errorMsg}</p>}

        <p className="waitlist-privacy">{t('waitlist.privacy')}</p>
      </div>
    </section>
  );
}
